import Add from './add.vue'

export default [{
    path: '/:type',
    name:'lyRoleAdd',
    component:Add,
}]